export { default } from './FaresGridBackgroundImage';
